import { useBrandingStore } from '../stores/brandingStore';

export function useBranding() {
    const branding = useBrandingStore((s) => s.branding);
    return {
        logoUrl: branding.logoUrl,
        logoWidth: branding.logoWidth,
        primaryColor: branding.primaryColor,
        secondaryColor: branding.secondaryColor,
        accentColor: branding.accentColor,
        faviconUrl: branding.faviconUrl,
    };
}
